/**
 * The runner scope every title animation of the round runs in (the gems, the eruptions, GROW, the meter, the collects,
 * the badges, the reveals, the board paying): the player's slam finishes it (`createPresentation`'s `slam`), and each
 * action runs it inside its own `runInScope` window, so a slam snaps the moment it hits and never the next one.
 */
export const FX_SCOPE = "coin_hold_fx";
